export class AccessTokenContainer{
    accessToken: string;
    accessTokenSecret: string;
    constructor(accessToken: string, accessTokenSecret: string){
        this.accessToken = accessToken;
        this.accessTokenSecret = accessTokenSecret;
    }
}